// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1-NkB","additionalInfo":"AgreementModal_additionalInfo__3W0DU"};